module.exports = __webpack_public_path__ + "img/hud-ring.b185f5f2.png";